<template>
  <v-dialog
    v-model="loading"
    persistent
    height="110"
    width="110"
  >
    <v-card
      color="primary"
      dark
      height="110"
      width="110"
    >
      <v-card-text>
        <v-progress-circular
          indeterminate
          color="white"
          :size="70"
          :width="7"
        ></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'Loader',
    computed: {
      loading () {
        return this.$store.getters.dataLoading
      }
    }
  }
</script>

<style scoped>
  .v-dialog>.v-card>.v-card__text {
    padding: 20px; 
  }
  .container-size {
    height: 110px;
    width: 110px;
  }
</style>>


// WEBPACK FOOTER //
// src/components/Loader/Loader.vue